import { useContext } from 'react'
import './style/landing.css'
import cloud1 from './assets/calculator.png'
import cloud2 from './assets/cloud3.png'
import star from './assets/star.png'

import { AppContext} from '../../contexts/AppProvider'

const Landing = (props) => {
    
    const { settings } = useContext(AppContext)
    console.log('question',settings.isAnimationPause)
    return (
        <div className="LandingPage">
            <div className="bacgroundTop">
                <img id="cloud1" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  className="cloud" src={cloud1} alt="" />
                <img id="cloud2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  className="cloud3" src={cloud2} alt="" />
                <img className="star rotate" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
                <img className="star2 rotate2" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
                <img className="star3 rotate3" style={{ animationPlayState: settings.isAnimationPause ? 'paused' : 'running'}}  src={star} alt="" />
            </div>
            {props.children}

        </div>
    )
}



export default Landing

